import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthContext } from '../../../features/auth/context/AuthContext';
import { useTheme } from '../../../features/theme/context/ThemeContext';
import UsageSection from '../../../features/profile/sections/organization/UsageSection';

/**
 * Usage tab content for AccountModal. Fetches org context and renders UsageSection.
 */
function UsageTab() {
  const { user } = useAuthContext();
  const { darkMode } = useTheme();
  const [organization, setOrganization] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const toastStyle = {
    style: {
      background: darkMode ? '#333' : '#fff',
      color: darkMode ? '#fff' : '#000',
      border: `1px solid ${darkMode ? '#444' : '#e2e8f0'}`,
    },
    success: {
      style: {
        background: darkMode ? '#0c4a2d' : '#ecfdf5',
        color: darkMode ? '#fff' : '#065f46',
        border: `1px solid ${darkMode ? '#065f46' : '#d1fae5'}`,
      },
    },
    error: {
      style: {
        background: darkMode ? '#4c1d24' : '#fef2f2',
        color: darkMode ? '#fff' : '#b91c1c',
        border: `1px solid ${darkMode ? '#b91c1c' : '#fee2e2'}`,
      },
    },
  };

  useEffect(() => {
    const fetchOrgContext = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setIsLoading(false);
          return;
        }
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/organization`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (data.hasOrganization && data.organization) {
          setOrganization(data.organization);
          setUserRole(data.organization.userRole || 'member');
        } else {
          setOrganization(null);
          setUserRole(null);
        }
      } catch (error) {
        console.error('Error fetching organization:', error);
        setOrganization(null);
        setUserRole(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrgContext();
  }, []);

  if (!user) {
    return (
      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4 flex flex-col items-center justify-center text-center">
        <p className="text-gray-500 dark:text-[#999999]" style={{ fontFamily: 'var(--chat-font-family)' }}>
          Sign in to view usage
        </p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4 flex items-center justify-center">
        <p className="text-gray-500 dark:text-[#999999]" style={{ fontFamily: 'var(--chat-font-family)' }}>
          Loading...
        </p>
      </div>
    );
  }

  if (!organization) {
    return (
      <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4 flex flex-col items-center justify-center text-center">
        <p className="text-sm text-[#737373] dark:text-[#999999]" style={{ fontFamily: 'var(--chat-font-family)' }}>
          You are not part of an organization. Contact your organization administrator to get invited.
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-4 py-4" style={{ fontFamily: 'var(--chat-font-family)' }}>
      <UsageSection
        user={user}
        organization={organization}
        userRole={userRole}
        toastStyle={toastStyle}
        darkMode={darkMode}
      />
    </div>
  );
}

export default UsageTab;
